/**
 * The dark-paper pairs (Olivia, REPLY-2026-10-06d §2): what a coloured paper
 * looks like on the canvas when the editor is in Dark. A dark page tinted
 * toward the paper's hue, never the true colour (a full cream or yellow sheet
 * in a dark surround is the glare Dark is chosen to avoid), and never left
 * unchanged (then nothing says the paper has a colour).
 *
 * Canvas only: the PDF, Preview and Export always use the true paper, so these
 * live on the web side and are not part of GET /api/themes.
 *
 * Classic, Cerulean and Index print on white, which has no hue to carry: they
 * have no pair and keep today's dark page.
 */
import type { ThemeId } from "@/lib/api";

export interface DarkPaper {
  /** The page ground. */
  paper: string;
  /** Body text. */
  ink: string;
  /** Headings. */
  heading: string;
}

/** Contrast, ink · headings: Carnet 11.9 · 6.5, Gazette 11.9 · 9.9, Exposition 11.9 · 8.4. */
export const DARK_PAPER: Readonly<Partial<Record<ThemeId, DarkPaper>>> = {
  carnet: { paper: "#2B2620", ink: "#EDE4D3", heading: "#E39A73" },
  gazette: { paper: "#2D2A16", ink: "#F1EAC8", heading: "#F3D54E" },
  // Exposition's own burgundy is already dark: the page keeps its true colour.
  exposition: { paper: "#4A1B22", ink: "#F3E9DC", heading: "#EBC155" },
};

/** The theme's dark-paper pair, or null when it prints on white. */
export function darkPaperFor(id: ThemeId | null | undefined): DarkPaper | null {
  return (id && DARK_PAPER[id]) || null;
}
